import { OnboardingStep } from '../../../../services/exports/Constants';

export default {
  [OnboardingStep.EmailVerification]: 'Vahvista sähköpostiosoite',
  [OnboardingStep.StoreDetails]: 'Myymälän tiedot',
  [OnboardingStep.BusinessInfo]: 'Yrityksen tiedot',
  // Outside Germany, where Store details and Business details are still one step.
  store_and_business_info: 'Lisää liikkeesi tiedot',
  [OnboardingStep.PersonalInfo]: 'Lisää henkilötietosi',
  // In Germany: the person who signs the contract, for a GmbH its managing director (Nishita).
  owner_personal_info: 'Omistajan henkilötiedot',
  owner_personal_info_gmbh: 'Omistajan / toimitusjohtajan henkilötiedot',
  [OnboardingStep.ShippingInfo]: 'Lisää toimitustietosi',
  [OnboardingStep.BankInfo]: 'Lisää pankkitiedot maksuja varten',
  [OnboardingStep.TaxInfo]: 'Onko yrityksesi arvonlisäverovelvollinen?',
  [OnboardingStep.BusinessDocs]: 'Yritystodistus',
  [OnboardingStep.PersonalDocs]: 'Henkilöllisyystodistus',
  [OnboardingStep.InfoSubmission]: 'Saa maksuja',
  confirm_info_gateway: 'Saa maksuja – {{paymentGateway}}',
  [OnboardingStep.PaymentInfo]: 'Maksutiedot',
  [OnboardingStep.Subscription]: 'Tilaus',
  [OnboardingStep.MobileApp]: 'Mobiilisovellus',
  [OnboardingStep.DeliveryStructure]: 'Toimitusrakenne',
  [OnboardingStep.Contract]: 'Sopimus',
  [OnboardingStep.ContractPayment]: 'Sopimusmaksu',
  [OnboardingStep.Documents]: 'Lataa asiakirjat',
  [OnboardingStep.PromoCode]: 'Alennuskoodi',
};
